"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const util_1 = require("./util");
exports.default = {
    Group: {
        genesis: (ticker, name, documentUrl, documentHash, decimals, mintBatonVout, quantity) => util_1.createOpReturnGenesis(0x81, ticker, name, documentUrl, documentHash, decimals, mintBatonVout, quantity),
        mint: (tokenIdHex, mintBatonVout, quantity) => util_1.createOpReturnMint(0x81, tokenIdHex, mintBatonVout, quantity),
        send: (tokenIdHex, slpAmounts) => util_1.createOpReturnSend(0x81, tokenIdHex, slpAmounts),
    },
    Child: {
        genesis: (ticker, name, documentUrl, documentHash) => util_1.createOpReturnGenesis(0x41, ticker, name, documentUrl, documentHash, 0, null, new bignumber_js_1.default(1)),
        send: (tokenIdHex, slpAmounts) => util_1.createOpReturnSend(0x41, tokenIdHex, slpAmounts),
    }
};
